export default "__VITE_ASSET__C8S7Pvdn__"